import {
  Dimensions,
  Image,
  ImageBackground,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
import { fp, hp, normalize, spH, spV, wp } from "utils/normalizeV2";

import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import Carousel from "react-native-reanimated-carousel";
import Heading from "components/Heading";
import { Images } from "assets";
import { Link } from "expo-router";
import Pagination from "src/components/Pagination";
import React from "react";
import VText from "components/VText";
import { memo } from "react";
import { trackV2 } from "utils/Segment";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { useState } from "react";
import { Helmet } from "react-helmet";

const SLIDER_WIDTH = Dimensions.get("window").width;

const IMAGE_HEIGHT = SLIDER_WIDTH / 2.4;

const HomeStories = ({ isInView = false, gender }) => {
  const [currentActiveIndex, setCurrentActiveIndex] = useState(0);

  const homeStories =
    useSelector((state) => state.HomeReducer.homeStories) || [];
  const homeStoriesLoading = useSelector(
    (state) => state.HomeReducer.homeStoriesLoading
  );
  const _checkoutPopUp = useSelector(
    (state) => state.UtilsReducer._checkoutPopUp
  );


  const _slider1Ref = useRef();

  const _renderItem = ({ item, index }) => {
    return (
      <View style={{}} activeOpacity={1} key={index}>
        {/* <Helmet>
               <meta name="keywords" content={item?.title + "," + item?.subTitle + "," + item?.authorName + "," + item?.aiTags + ",Vetir App, Vetir, Designer Clothes, Shoes, Bags & Accessories"} />
        </Helmet> */}
        <Link
          onPress={() => {
            _checkoutPopUp?.current?.hide();
            const eventData = {
              current_section: gender === "female" ? "Women" : "Men",
              story_id: item?.id,
            };
            trackV2(ANALYTICS_EVENT_NAMES.STORY_IMAGE_CLICKED, eventData);
          }}
          href={`${gender == 'men' ? '/men' : ''}/stories-details/${item?.id}/${item?.title
            .toLowerCase()
            .replace(" ", "-")}?source=homepage_story_image`}
        >
          <ImageBackground
            accessibilityLabel={item?.title}
            source={{ uri: item?.thumbnailWebUrl || item?.imageUrl }}
            style={{
              backgroundColor: "black",
              width: SLIDER_WIDTH,
              height: IMAGE_HEIGHT,
              resizeMode: "cover",
            }}
            resizeMode="cover"
          ></ImageBackground>
        </Link>
        <View
          style={{
            flex: 1,
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <Heading
            type="h3"
            style={{
              textAlign: "center",
              fontSize: normalize(32),
              fontFamily: "Libre Bodoni",
              fontWeight: "400",
              zIndex: 100,
              paddingTop: spV(16),
            }}
          >
            {item?.title}
          </Heading>
          <Heading
            type="h4"
            style={{
              textAlign: "center",
              fontSize: fp(18),
              fontFamily: "Libre Bodoni",
              fontWeight: "400",
              zIndex: 100,
              paddingTop: spV(8),
            }}
          >
            {item?.subTitle}
          </Heading>
          <Link
            onPress={() => {
              _checkoutPopUp?.current?.hide();
              const eventData = {
                current_section: gender === "female" ? "Women" : "Men",
                story_id: item?.id,
                cta_text: item?.cta || "Read More",
              };
              trackV2(ANALYTICS_EVENT_NAMES.STORY_CTA_CLICKED, eventData);
            }}
            href={`${gender == 'men' ? '/men' : ''}/stories-details/${item?.id}/${item?.title
              .toLowerCase()
              .replace(" ", "-")}?source=homepage_story_cta`}
          >
            <VText
              style={{
                fontWeight: "500",
                textAlign: "center",
                fontSize: normalize(16),
                fontFamily: "Libre Bodoni",
                fontWeight: "550",
                zIndex: 100,
                paddingTop: spV(8),
                textDecorationLine: "underline",
              }}
            >
              {item?.cta || "Read More"}
            </VText>
          </Link>
        </View>
      </View>
    );
  };
  if (
    (Array.isArray(homeStories) && homeStories?.length > 0) ||
    homeStoriesLoading
  ) {
    return (
      <View
        style={{
          paddingBottom: 8,
        }}
      >
        {!homeStoriesLoading && (
          <>
            <Carousel
              loop
              width={SLIDER_WIDTH}
              panGestureHandlerProps={{
                activeOffsetX: [-10, 10],
              }}
              height={IMAGE_HEIGHT + hp(140)} // added 32 + extra for dynamic image height
              ref={_slider1Ref}
              scrollEnabled={true}
              autoPlay={true}
              pagingEnabled
              autoPlayInterval={4000}
              data={Array.isArray(homeStories) ? homeStories?.slice(0, 3) : []}
              scrollAnimationDuration={2000}
              onSnapToItem={(index) => setCurrentActiveIndex(index)}
              renderItem={_renderItem}
            />

            <Pagination
              data={Array.isArray(homeStories) ? homeStories?.slice(0, 3) : []}
              selectedIndex={currentActiveIndex}
              containerStyle={{
                marginTop: spV(20),
                paddingBottom: 8,
                alignItems: "center",
                justifyContent: "center",
              }}
            />

            <TouchableOpacity
              style={[styles.navButton, styles.navButtonLeft]}
              onPress={() => {
                _slider1Ref.current?.prev();
              }}
            >
              <Image
                accessibilityLabel="Left Arrow"
                style={styles.navButtonImage}
                source={Images.left}
              />
            </TouchableOpacity>
            <TouchableOpacity
              style={[styles.navButton, styles.navButtonRight]}
              onPress={() => {
                _slider1Ref.current?.next();
              }}
            >
              <Image
                accessibilityLabel="Right Arrow"
                style={styles.navButtonImage}
                source={Images.right}
              />
            </TouchableOpacity>
          </>
        )}
      </View>
    );
  } else {
    return <></>;
  }
};

const styles = StyleSheet.create({
  navButton: {
    position: "absolute",
    top: "42%",
    borderRadius: 20,
    padding: 10,
  },
  navButtonLeft: {
    left: 10,
  },
  navButtonRight: {
    right: 10,
  },
  navButtonImage: {
    height: spH(30),
    width: spH(30),
  },
});

export default memo(HomeStories);
